<div class="login-logo background-primary"></div>
<div class="login-form background-primary">
  <form class="white-input" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div [ngClass]="{ 'form-inputs': true, 'pwd-active': !sso }">
      <mat-form-field>
        <mat-label>{{ "login.mailPHolder" | translate }}</mat-label>
        <input matInput type="email" formControlName="email" required />
        @if (loginForm.controls.email.hasError("required")) {
          <mat-error [innerHTML]="'login.usernameError' | translate">
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field [ngClass]="{ 'pwd-input': true, active: !sso }">
        <mat-label>{{ "login.pwdPHolder" | translate }}</mat-label>
        <input matInput type="password" formControlName="pwd" required />
        @if (loginForm.controls.pwd.hasError("required")) {
          <mat-error [innerHTML]="'login.pwdError' | translate"> </mat-error>
        }
      </mat-form-field>
    </div>
    <button mat-button>{{ "login.login" | translate }}</button>
  </form>
</div>
<div class="login-footer background-primary"></div>
